module.exports = __webpack_public_path__ + "static/media/thumb-up.227adea8.svg";